module.exports = __webpack_public_path__ + "static/media/lnns.3c5e2f9d.PNG";